<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="亚专业名称">
              <a-input placeholder="请输入亚专业名称" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="所属科室">
              <a-input placeholder="请输入科室名称" v-model="queryParam.deptName"></a-input>
            </a-form-item>
          </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                  <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <tempConfigSubMajor-modal ref="modalForm" @ok="modalFormOk"></tempConfigSubMajor-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import TempConfigSubMajorModal from './modules/TempConfigSubMajorModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
// import TempConfigSubMajorModal from './modules/TempConfigSubMajorModal.vue';

  export default {
    name: "TempConfigSubMajorList",
    mixins:[JeecgListMixin],
    components: {
      TempConfigSubMajorModal
    },
    data () {
      return {
        description: '项目配置-知识库-亚专业管理页面',
        // 表头
        columns: [
		   {
            title: '亚专业名称',
            align:"center",
            dataIndex: 'name'
           },
		   {
            title: '所属科室',
            align:"center",
            dataIndex: 'deptName'
           },
		   {
            title: '是否启用',
            align:"center",
            dataIndex: 'enabled_dictText',
           },
		   {
            title: '关键字',
            align:"center",
         ellipsis: true, //表格省略
            dataIndex: 'keyword',
           },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
		url: {
          list: "/tempconfig/tempConfigSubmajor/list",
          delete: "/tempconfig/tempConfigSubmajor/delete",
       },
    }
  },
  computed: {
  },
    methods: {
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>